export default __webpack_public_path__ + "media/splashpage/bg-full-left-19f76c1d.svg";